import React, { useEffect, useState } from "react";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  DeleteQuoteApi,
  GetAllSalesByStoreID,
  // GetAllStores,
  PrintQuoteApi,
  // TransferSalesOrderApi,
} from "../../api";
import { Header, Button } from "../../components";
import "../../styles/viewCustomer.css";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import {
  showSuccessToast,
  showErrorToast,
  showInfoToast,
} from "../../components/ToastMesg";
// import PopupSelectField from "../../components/PopupSelectField";
import DataGrid from "../../components/DataGrid";

const Quotes = () => {
  const { storeG, userPermID } = useStateContext();
  const [AllOrders, setAllOrders] = useState("");
  const [order, setOrder] = useState("");
  // const [storeOptions, setStoreOptions] = useState([]);
  // const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const PartGridactiveStatus = (props) => (
    <div className="flex gap-2 justify-center items-center text-white font-bold">
      <label
        className={`py-2 px-2 rounded-2xl ${props.so_status === "Closed" ? "text-gray-800" : props.so_status === "Canceled" ? "text-red-700" : props.so_status === "Hold" ? "text-amber-900" : props.so_status === "Open" ? "text-blue-800" : "text-green-800"}`}
      >
        {props.so_status}
      </label>
    </div>
  );
  const soIdTemp = (props) => <div>{`${props.quote_sale}${props.so_id}`}</div>;

  const customersGrid = [
    {
      field: "quote_sale",
      template: soIdTemp,
      headerText: "Q #",
      minWidth: "110",
      width: "110",
      maxWidth: "120",
      textAlign: "right",
    },
    {
      field: "quote_date",
      headerText: "Quote Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "155",
      width: "165",
      maxWidth: "170",
      textAlign: "Center",
    },
    {
      field: "customer",
      headerText: "Customer",
      minWidth: "160",
      width: "190",
      maxWidth: "360",
      textAlign: "left",
    },
    {
      field: "so_status",
      headerText: "Status",
      template: PartGridactiveStatus,
      minWidth: "120",
      width: "120",
      maxWidth: "130",
      textAlign: "left",
    },
    {
      field: `total_price`,
      headerText: "Total Amt",
      format: "C2",
      minWidth: "135",
      width: "140",
      maxWidth: "150",
      textAlign: "right",
    },
    {
      field: "user_note",
      headerText: "User Note",
      minWidth: "140",
      width: "200",
      maxWidth: "420",
      textAlign: "left",
    },
  ];

  const handleRowSelected = (args) => setOrder(args.data);

  const handlePrintQuoteClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (order) {
      if (window.confirm(`Do you want to show the price of this Quote?`)) {
        const resp = await PrintQuoteApi(order.so_id, true);
        if (!resp) showErrorToast("Error!", "Record not found!");
      } else {
        const resp = await PrintQuoteApi(order.so_id, false);
        if (!resp) showErrorToast("Error!", "Record not found!");
      }
    } else showInfoToast("Info!", "Please select Quote to print!");
  };

  const handleAddQuoteClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (order && window.confirm(`Do you want to copy the selected Quote?`))
      localStorage.setItem("copyOrder", order.so_id);
    window.open(`/Quotes/AddQuotation`, "_blank");
  };

  const handleEditQuoteClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (order) window.open(`/Quotes/EditQuotation/${order.so_id}`, "_blank");
    else showInfoToast("Info!", "Please Select Quote to edit!");
  };

  const handleDeleteQuoteClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      if (order) {
        if (window.confirm(`Are you sure you want to Delete this Quote?`)) {
          const resp = await DeleteQuoteApi(order.so_id);
          if (resp.success) {
            showSuccessToast("Success!", "Quote deleted successfully.");
            window.location.reload();
          } else
            showErrorToast("Error!", "Quote failed to delete: " + resp.message);
        }
      } else showInfoToast("Info!", "Please select Quote to delete!");
    } catch (error) {
      showErrorToast("Error!", "Quote failed to delete!");
    }
  };

  const handleConvQuoteClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (order) window.open(`/Quotes/ConvertQuote/${order.so_id}`, "_blank");
    else showInfoToast("Info!", "Please Select Quote!");
  };

  // const handleTransferClick = async (event) => {
  //   TimeoutUtility.resetTimeout();
  //   event.preventDefault();
  //   if (order) {
  //     if (order.any_shipped)
  //       showErrorToast(
  //         "Error!",
  //         "This Order is already shipped and therefore cannot be transfered to another store!",
  //       );
  //     else setIsDialogOpen(true);
  //   } else showInfoToast("Info!", "Please Select Order!");
  // };

  // const handleTransferOrderStore = async (store) => {
  //   TimeoutUtility.resetTimeout();
  //   if (!order) {
  //     showErrorToast("Error!", "Please select an order to transfer!");
  //     return;
  //   }
  //   if (!store || !store.value) {
  //     showErrorToast("Error!", "Please select a store to transfer the order!");
  //     return;
  //   }
  //   if (store.value === order.store_id) {
  //     showErrorToast(
  //       "Error!",
  //       "This Transfer Order cannot be processed as the selected store is the same as the original store!\n\nTry again after selecting a different store.",
  //     );
  //     return;
  //   }
  //   if (
  //     window.confirm(
  //       `Are you sure you want to transfer this Order to ${store.label}?`,
  //     )
  //   ) {
  //     try {
  //       const resp = await TransferSalesOrderApi(order.so_id, store.value);
  //       if (resp.success) {
  //         showSuccessToast("Success!", "Order transfered successfully!");
  //         window.location.reload();
  //       } else
  //         showErrorToast("Error!", "Order failed to transfer: " + resp.message);
  //     } catch (error) {
  //       showErrorToast("Error!", "Account failed to delete!");
  //     }
  //   }
  // };

  const handleViewQuoteClick = () => {
    TimeoutUtility.resetTimeout();
    if (order) window.open(`/Quotes/ViewQuotation/${order.so_id}`, "_blank");
    else showInfoToast("Info!", "Please Select Order!");
  };

  // useEffect(() => {
  //   async function fetchData() {
  //     await GetAllStores()
  //       .then((resp) => {
  //         const storeOpt = resp.data.map((item) => ({
  //           label: item.name,
  //           value: item.store_id,
  //         }));
  //         setStoreOptions(storeOpt || []);
  //       })
  //       .catch((err) => {
  //         console.log(err.message);
  //       });
  //   }
  //   fetchData();
  // }, []);

  const handleRefresh = async () => {
    if (storeG?.store_id) {
      const resp = await GetAllSalesByStoreID(storeG.store_id, "Q");
      setAllOrders(resp.data || []);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id)
        trackPromise(
          GetAllSalesByStoreID(storeG.store_id, "Q")
            .then((result) => setAllOrders(result.data || []))
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
    }
    fetchData();
  }, [storeG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header category="Orders" title="QUOTES" />
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={2} className="button-row justify-content-end font-normal">
          {userPermID.includes(51) && (
            <Col md="auto p-0">
              <Button text="Add" onClick={handleAddQuoteClick} />
            </Col>
          )}
          {userPermID.includes(52) && (
            <>
              <Col md="auto p-0">
                <Button text="Update" onClick={handleEditQuoteClick} />
              </Col>
              {/* <Col md="auto p-0">
                <Button text="Transfer Quote" onClick={handleTransferClick} />
              </Col> */}
              <Col md="auto p-0">
                <Button text="Delete" onClick={handleDeleteQuoteClick} />
              </Col>
            </>
          )}
          {userPermID.includes(29) && (
            <Col md="auto p-0">
              <Button text="Convert to Sale" onClick={handleConvQuoteClick} />
            </Col>
          )}
          {userPermID.includes(50) && (
            <Col md="auto p-0">
              <Button text="Print" onClick={handlePrintQuoteClick} />
            </Col>
          )}
        </Row>
        {/* <PopupSelectField
          isOpen={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
          onSelect={(store) => handleTransferOrderStore(store)}
          options={storeOptions}
          // initialValue={someDefault}
          // title="Pick Your Location"
          // message="We need this to show nearby offers."
        /> */}
      </Container>
      <DataGrid
        loading={loading || promiseInProgress}
        data={AllOrders}
        cols={customersGrid}
        handleRowSelected={handleRowSelected}
        handleDoubleClick={userPermID.includes(50) && handleViewQuoteClick}
        persistant={true}
        handleRefresh={handleRefresh}
      />
    </div>
  );
};

export default Quotes;
